
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Icon from "@/components/UI/Icon.vue";
import { VariableType } from "@/oxygen/variables/lib/types";

@Component({
  components: {
    Icon
  }
})
export default class VariableIcon extends Vue {
  @Prop()
  type!: VariableType;

  @Prop()
  override!: boolean;

  @Prop({ default: 14 })
  iconSize!: number;

  get icon() {
    if (this.override) return "SwapIcon";

    const iconMap: Record<VariableType, unknown> = {
      color: "CircleHalfStrokeIcon",
      unit: "ExpandIcon",
      font_family: "HeadingIcon",
      number: "HashtagIcon",
      text: "TextIcon",
      image_url: "ImageIcon"
    };

    return iconMap[this.type] || "TextIcon";
  }
}
